import { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'

import { FormattedNumber } from '@10xLabs/react-web/components/FormattedNumber'
import { StyledLink } from 'components/v2/Link'
import Modal from 'components/v2/Modal'
import Heading from 'components/v2/Heading'
import { TableContainer, Table, Thead, Th, Tbody, Tr, Td } from '@10xLabs/react-web/components/Table'
import { containersMessages } from 'features/Snacks/components/Containers/messages'
import { safeFormatMessage } from 'utils/intl'

const ItemUnit = styled.span<TSFixMe>`
  white-space: nowrap;
`

export const ComboComponents = ({ components }: TSFixMe): TSFixMe => {
  const intl = useIntl()

  const [isModalOpen, setModalOpen] = useState(false)

  return (
    <div>
      <StyledLink onClick={(): TSFixMe => setModalOpen(true)}>{components.length}</StyledLink>

      {isModalOpen && (
        <Modal.Container large>
          <Modal.Header onClose={(): TSFixMe => setModalOpen(false)}>
            <Heading.H5>
              <FormattedMessage id="spanish.dictionary.products" defaultMessage="Productos" />
            </Heading.H5>
          </Modal.Header>

          <Modal.Content>
            <TableContainer overflow>
              <Table>
                <Thead>
                  <Tr>
                    <Th>
                      <FormattedMessage id="spanish.dictionary.name" defaultMessage="Nombre" />
                    </Th>

                    <Th>
                      <FormattedMessage id="spanish.dictionary.container" defaultMessage="Envase" />
                    </Th>

                    <Th>
                      <FormattedMessage id="spanish.dictionary.quantity" defaultMessage="Cantidad" />
                    </Th>
                  </Tr>
                </Thead>

                <Tbody>
                  {components.map((component: TSFixMe, index: TSFixMe): TSFixMe => {
                    const product = component.eligibleItems[0]

                    return (
                      <Tr key={index}>
                        <Td>{product.name}</Td>

                        <Td>
                          <FormattedMessage
                            id="spanish.items.list.container.value"
                            defaultMessage="{container} de {netContent}"
                            values={{
                              container: safeFormatMessage({
                                intl,
                                messages: containersMessages,
                                key: product.container
                              }),
                              netContent: (
                                <ItemUnit>
                                  <FormattedNumber value={product.netContent} /> {product.units}
                                </ItemUnit>
                              )
                            }}
                          />
                        </Td>

                        <Td>
                          <FormattedNumber value={component.quantity} />
                        </Td>
                      </Tr>
                    )
                  })}
                </Tbody>
              </Table>
            </TableContainer>
          </Modal.Content>
        </Modal.Container>
      )}
    </div>
  )
}
